import React from 'react';
import {
  Col,
  Card,
  Button,
  CardBody,
  ListGroup,
  CardHeader,
  ButtonGroup,
  DropdownItem,
  DropdownMenu,
  ListGroupItem,
  DropdownToggle,
  UncontrolledButtonDropdown,
  CardFooter,
} from 'reactstrap';

export const ListCategories = (props) => {
  return (
    <Col xs={6} md={6} lg={6}>
      <Card>
        <CardHeader>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <h4 className="card-title mb-0">{props.title}</h4>
            <Button className="btn-sm" onClick={props.navigation}>
              Nova
            </Button>{' '}
          </div>
        </CardHeader>

        <CardBody>
          <ListGroup className="col nested-list nested-sortable">
            {props.data.map((item, index) => (
              <div key={index}>
                {!item.set1 ? (
                  <Col lg={12} key={index} className="nestedlist-item mb-3">
                    <React.Fragment>
                      <ListGroupItem
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                      >
                        {item.title}
                      </ListGroupItem>
                    </React.Fragment>
                  </Col>
                ) : (
                  <Col lg={12} key={index} className="nestedlist-item mb-3">
                    <React.Fragment>
                      <ListGroupItem
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                      >
                        {item.title}
                        <ButtonGroup>
                          <UncontrolledButtonDropdown>
                            <DropdownToggle
                              color="primary"
                              className="btn-primary btn-sm"
                              style={{
                                borderRadius: '3px',
                              }}
                            >
                              <i className="ri-more-2-line" />
                            </DropdownToggle>
                            <div>
                              <DropdownMenu>
                                <DropdownItem
                                  onClick={() => props.handleEdit(item.id)}
                                >
                                  Editar
                                </DropdownItem>
                                <DropdownItem
                                  onClick={() => props.handleDelete(item.id)}
                                >
                                  Apagar
                                </DropdownItem>
                              </DropdownMenu>
                            </div>
                          </UncontrolledButtonDropdown>
                        </ButtonGroup>
                      </ListGroupItem>

                      {item.set1.length > 0 && (
                        <ListGroupItem>
                          {item.set1.map((child, index) => (
                            <ListGroup key={index}>
                              <ListGroupItem
                                className="nested-1"
                                style={{
                                  display: 'flex',
                                  paddingLeft: '20px',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                }}
                              >
                                {child.title}
                                <ButtonGroup>
                                  <UncontrolledButtonDropdown>
                                    <DropdownToggle
                                      color="primary"
                                      className="btn-primary btn-sm"
                                      style={{
                                        borderRadius: '3px',
                                      }}
                                    >
                                      <i className="ri-more-2-line" />
                                    </DropdownToggle>
                                    <DropdownMenu>
                                      <DropdownItem
                                        onClick={() =>
                                          props.handleEdit(child.id)
                                        }
                                      >
                                        Editar
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={() =>
                                          props.handleDelete(child.id)
                                        }
                                      >
                                        Apagar
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </UncontrolledButtonDropdown>
                                </ButtonGroup>
                              </ListGroupItem>
                            </ListGroup>
                          ))}
                        </ListGroupItem>
                      )}
                    </React.Fragment>
                  </Col>
                )}
              </div>
            ))}
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
